import React from 'react';
import { millisecondToISODate } from '../../../common/utils';
import { useAccurityTimezone } from '../../../timezoneProvider/AccurityTimezoneProvider';
import { DEFAULT_MULTIVALUE_SEPARATOR } from '../../types';
var formatValue = function (value, timezone, format) {
    if (Array.isArray(value)) {
        return value
            .map(function (valueElement) { return millisecondToISODate(valueElement, timezone, format); })
            .join(DEFAULT_MULTIVALUE_SEPARATOR);
    }
    else if (typeof value === 'number') {
        return millisecondToISODate(value, timezone, format);
    }
    else {
        return value || '';
    }
};
var DateCell = function (_a) {
    var value = _a.value, format = _a.format;
    var timezone = useAccurityTimezone();
    return React.createElement("span", null, formatValue(value, timezone, format));
};
export default DateCell;
//# sourceMappingURL=DateCell.js.map